require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/object/values.js
// module id = 416
// module chunks = 0